import { initializeApp } from 'firebase/app'
import { getAuth, connectAuthEmulator } from 'firebase/auth'
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore'

const app = initializeApp({
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY ?? 'fake-api-key',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
})

export const firebaseAuth = getAuth(app)

// Notificações em tempo real de movimentação de cartões (/andamento-contas, /mapa-resultado)
// — vive no mesmo projeto Firebase usado para Auth (ver terraform/main.tf seção 12: o Firestore
// fica no projeto do Identity Platform, não no GCP:ProjectId de cada ambiente).
export const firestoreDb = getFirestore(app)

if (process.env.REACT_APP_FIREBASE_EMULATOR_URL) {
  connectAuthEmulator(firebaseAuth, process.env.REACT_APP_FIREBASE_EMULATOR_URL, { disableWarnings: true })
}

if (process.env.REACT_APP_FIRESTORE_EMULATOR_HOST) {
  const [host, port] = process.env.REACT_APP_FIRESTORE_EMULATOR_HOST.split(':')
  connectFirestoreEmulator(firestoreDb, host, Number(port))
}
